<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>

<div class="container" *ngIf="!isLoading">
  <h2>Esquema de pozo</h2>
  <h3 *ngIf="casings.length === 0">
    No hay datos disponibles para graficar el esquema
  </h3>
  <div class="well-wrapper" *ngIf="casings.length > 0">
    <div class="well-diagram">
      <div class="surface">
        <div class="surface-label">SUPERFICIE (0 m)</div>
      </div>

      <div class="depth-scale">
        @for (depth of depthScale; track depth) {
        <div class="depth-label" [ngStyle]="{ top: depthToPx(depth) }">
          {{ depth }}m
        </div>
        }
      </div>

      @if (visibilityState.cement) { @for (cementing of cementings; track
      $index) {
      <div
        class="cement-sheath cement-{{ cementing.casingType }}"
        [ngStyle]="{
          top: depthToPx(cementing.top),
          height: calculateHeight(cementing.top, cementing.base)
        }"
        [title]="getCementingTooltip(cementing)"
      ></div>
      } } @for (casing of casings; track casing.casingId) {
      <div
        class="casing casing-{{ casing.type }}"
        [ngStyle]="{
          top: depthToPx(casing.top),
          height: calculateHeight(casing.top, casing.base)
        }"
        [title]="getCasingTooltip(casing)"
      >
        @if (casing.hasShoe) {
        <div class="shoe"></div>
        }
      </div>
      } @for (perforation of perforations; track $index) { @if
      ((perforation.rePerforation == 'N' && visibilityState.punzado) ||
      (perforation.rePerforation == 'S' && visibilityState.repunzado)) {
      <div
        class="marker marker-{{
          perforation.rePerforation == 'N' ? 'punzado' : 'repunzado'
        }}"
        [ngStyle]="{ top: depthToPx(perforation.top) }"
        [title]="getPerforationTooltip(perforation)"
      >
        @if (perforation.rePerforation == 'S') {
        <div class="marker-repunzado-arrow-left"></div>
        <div class="marker-repunzado-arrow-right"></div>
        }
      </div>
      } } @if (visibilityState.fracture) { @for (stimulation of stimulations;
      track $index) {
      <div
        class="marker marker-fracture"
        [ngStyle]="{ top: depthToPx(stimulation.top) }"
        [title]="getFractureTooltip(stimulation)"
      >
        <div class="marker-fracture-arrow-left"></div>
        <div class="marker-fracture-arrow-right"></div>
      </div>
      } } @if (visibilityState.stimulation) { @for (acidification of
      acidifications; track $index) {
      <div
        class="marker marker-stimulation"
        [ngStyle]="{ top: depthToPx(acidification.top) }"
        [title]="getStimulationTooltip(acidification)"
      >
        <div class="marker-stimulation-arrow-left"></div>
        <div class="marker-stimulation-arrow-right"></div>
      </div>
      } } @if (visibilityState.breakCasing) { @for (breakCasing of breakCasings;
      track $index) {
      <div
        class="marker marker-casing-break"
        [ngStyle]="{ top: depthToPx(breakCasing.top) }"
        [title]="getBreakCasingTooltip(breakCasing)"
      ></div>
      } } @if (visibilityState.fishing) { @for (fishing of fishings; track
      $index) {
      <div
        class="marker"
        [ngStyle]="{ top: depthToPx(fishing.base) }"
        [title]="getFishingTooltip(fishing)"
      >
        <mat-icon class="material-icons-outlined phishing-icon"
          >phishing</mat-icon
        >
      </div>
      } }
    </div>

    <div class="legend">
      <h3>Simbología</h3>
      <div class="legend-section">
        <div style="margin-top: 8px">
          <div class="legend-item">
            <div class="legend-box" style="background: #e8b887"></div>
            <span>Casing</span>
          </div>
          <div class="legend-item">
            <div
              class="legend-box"
              style="background: #d0d0d0; border-color: #808080"
            ></div>
            <span>Cemento</span>
            <input type="checkbox" [(ngModel)]="visibilityState.cement" />
          </div>
          <div class="legend-item">
            <div
              class="legend-line legend-line-arrow"
              style="background: #000; color: #000"
            ></div>
            <span>Punzado</span>
            <input type="checkbox" [(ngModel)]="visibilityState.punzado" />
          </div>
          <div class="legend-item">
            <div
              style="
                width: 40px;
                height: 4px;
                position: relative;
                flex-shrink: 0;
              "
              class="legend-line-arrow legend-line-arrow-repunzado"
            >
              <div
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 1px;
                  background: #000;
                "
              ></div>
              <div
                style="
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 100%;
                  height: 1px;
                  background: #000;
                "
              ></div>
            </div>
            <span>Repunzado</span>
            <input type="checkbox" [(ngModel)]="visibilityState.repunzado" />
          </div>
          <div class="legend-item">
            <div
              style="
                width: 40px;
                height: 2px;
                position: relative;
                flex-shrink: 0;
              "
              class="legend-line-arrow legend-line-arrow-fracture"
            >
              <div
                style="
                  position: absolute;
                  left: 0;
                  width: 15px;
                  height: 2px;
                  background: #9b59b6;
                "
              ></div>
              <div
                style="
                  position: absolute;
                  right: 0;
                  width: 15px;
                  height: 2px;
                  background: #9b59b6;
                "
              ></div>
            </div>
            <span>Estimulación Fractura</span>
            <input type="checkbox" [(ngModel)]="visibilityState.fracture" />
          </div>
          <div class="legend-item">
            <div
              style="
                width: 40px;
                height: 2px;
                position: relative;
                flex-shrink: 0;
              "
              class="legend-line-arrow-stimulation"
            >
              <div
                style="
                  position: absolute;
                  left: 0px;
                  width: 15px;
                  height: 2px;
                  background: #3498db;
                "
              ></div>
              <div
                style="
                  position: absolute;
                  right: 0;
                  width: 15px;
                  height: 2px;
                  background: #3498db;
                "
              ></div>
            </div>
            <span>Estimulación Ácida</span>
            <input type="checkbox" [(ngModel)]="visibilityState.stimulation" />
          </div>
          <div class="legend-item">
            <div>
              <mat-icon class="material-icons-outlined phishing-icon"
                >phishing</mat-icon
              >
            </div>
            <span>Pesca</span>
            <input type="checkbox" [(ngModel)]="visibilityState.fishing" />
          </div>
          <div class="legend-item">
            <div class="legend-marker-casing-break"></div>
            <span>Casing Roto</span>
            <input type="checkbox" [(ngModel)]="visibilityState.breakCasing" />
          </div>
          <div class="legend-item">
            <div
              style="
                width: 40px;
                height: 20px;
                position: relative;
                flex-shrink: 0;
              "
            >
              <div
                style="
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 0;
                  height: 0;
                  border-bottom: 20px solid #333;
                  border-left: 15px solid transparent;
                "
              ></div>
              <div
                style="
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  width: 0;
                  height: 0;
                  border-bottom: 20px solid #333;
                  border-right: 15px solid transparent;
                "
              ></div>
            </div>
            <span>Zapato</span>
          </div>
        </div>
        <div
          style="
            margin-top: 20px;
            padding: 12px 12px 4px 12px;
            background: white;
            border-radius: 6px;
            border: 1px solid #ddd;
          "
        >
          <div style="font-size: 11px; color: #666; margin-bottom: 8px">
            <strong>Profundidad Total:</strong> {{ maxDepth }} m
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
